export enum CategoryType {
  EXAM = 'EXAM', PREP = 'PREP'
}
